import { useState } from "react"
import { Link } from "react-router-dom"
import { ArrowLeft, Search, FileText } from "lucide-react"
import { Input } from "../components/ui/input.tsx"
import { Button } from "../components/ui/button.tsx"

export default function MyOrdersPage() {
  const [searchQuery, setSearchQuery] = useState("")

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-6 md:py-8 max-w-5xl">
        <Link to="/" className="inline-flex items-center text-gray-600 hover:text-primary mb-4 md:mb-6">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </Link>

        <h1 className="text-3xl font-semibold mb-6">My Orders</h1>

        <div className="relative mb-6">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
          <Input
            placeholder="Search by test name"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-10 py-6 text-base"
          />
        </div>

        <div className="bg-white rounded-lg shadow-sm p-12">
          <div className="flex flex-col items-center justify-center text-center">
            <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center mb-4">
              <FileText className="w-10 h-10 text-red-600" />
            </div>
            <h2 className="text-xl font-semibold mb-2">No Orders Found</h2>
            <p className="text-gray-600 mb-6">You haven't placed any orders yet.</p>
            <Button asChild className="bg-red-700 hover:bg-red-800">
              <Link to="/book-now">Book a Test</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
